/* Copied from https://stackoverflow.com/a/6667246 😅 */

import format from 'date-fns/format';
import parseISO from 'date-fns/parseISO';
import { addDays, subDays, startOfWeek, endOfWeek } from 'date-fns';

function adjustForUTCOffset(date: any) {
  return new Date(
    date.getUTCFullYear(),
    date.getUTCMonth(),
    date.getUTCDate(),
    date.getUTCHours(),
    date.getUTCMinutes(),
    date.getUTCSeconds()
  );
}

export function formatDate(dateString: string) {
  try {
    const date = parseISO(dateString);
    const dateWithOffset = adjustForUTCOffset(date);
    return {
      date: format(dateWithOffset, 'dd-MM-yyyy'),
      time: `${format(dateWithOffset, 'HH:mm')} UTC`,
    };
  } catch (e) {
    return {
      date: '',
      time: '',
    };
  }
}

export function dateToUTC(dateString: string): any {
  const date = new Date(dateString);
  const dateWithOffset = new Date(
    date.getTime() - date.getTimezoneOffset() * 60000
  );

  return dateWithOffset;
}

/**
 * Calculating first and last day in a week for the given date.
 * @param date
 * @returns
 */
export function getWeekDateRange(date: Date) {
  const startDayOfWeek = startOfWeek(date, { weekStartsOn: 0 }).toISOString();
  const endDayOfWeek = endOfWeek(date, { weekStartsOn: 0 }).toISOString();
  return { startDayOfWeek, endDayOfWeek };
}

// --------------------------------------
/**
 * Calculating previous week date range by subtracting 24h from the first day of the given week
 * @param activeWeek
 * @returns
 */
export function getPrevWeekRange(activeWeek: {
  startDayOfWeek: string;
  endDayOfWeek: string;
}) {
  const date = new Date(activeWeek.startDayOfWeek);
  const reffDay = subDays(date, 1);
  return getWeekDateRange(reffDay);
}

/**
 * Calculating next week date range by adding 24h to the the last day of the given week
 * @param activeWeek
 * @returns
 */
export function getNextWeekRange(activeWeek: {
  startDayOfWeek: string;
  endDayOfWeek: string;
}) {
  const date = new Date(activeWeek.endDayOfWeek);
  const reffDay = addDays(date, 1);
  return getWeekDateRange(reffDay);
}
